import React from "react";
import { PropTypes } from "prop-types";
import { Link } from "react-router-dom";

const Panel = ({ subtitle, header, text, link, color }) => (
  <div
    className="row align-items-center panels pt-md-3 pb-md-0"
    style={{
      margin: "2em 0",
      background: `linear-gradient(to right, var(--${color}-color) 12px, var(--secondary-bg) 12px)`
    }}
  >
    <div className="col">
      <span className={`subtitle txt-${color} mb-md-5`}>{`/${subtitle}`}</span>
      <h5>{header}</h5>
      <p className="txt-light-gray">{text}</p>
    </div>
    <div className="col-md-4 d-md-flex justify-content-end">
      <Link to={link}>
        <button className="btn btn-primary">Get Started</button>
      </Link>
    </div>
  </div>
);

Panel.propTypes = {
  subtitle: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  color: PropTypes.oneOf(["red", "yellow", "green", "blue"]).isRequired
};

Panel.defaultProps = {
  color: "red"
};

export { Panel };
